import styled from 'styled-components';
import { Breadcrumb } from '@ibinder/ui-common-core';

export const StyledBreadcrumb = styled(Breadcrumb)`
  padding-right: 0.625rem;
  > p {
    height: 1.875rem;
    line-height: 1.875rem;
  }
`;
